import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ColorEnum } from "@/modules/vue/enums";
import { generateColorMap } from "@/modules/vue/utils";
export default /*#__PURE__*/_defineComponent({
  __name: 'PlayerInfo',
  props: {
    unknown: null,
    color: {
      default: ColorEnum.Green
    }
  },
  setup(__props) {
    const props = __props;
    const colorMap = generateColorMap({
      border: 500
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["border-4 rounded-full text-2xl font-bold text-gray-500 w-[4rem] h-[4rem] flex-center outline-2", {
          'border-gray-500 opacity-40': __props.unknown,
          [_unref(colorMap)[__props.color]]: !__props.unknown
        }])
      }, [_renderSlot(_ctx.$slots, "default")], 2);
    };
  }
});